export default __webpack_public_path__ + "static/media/title_en_pc@2x.9e6d5aec.png";